import { apiFetch, isErrorResult } from "../../../../app/apiClient.js";
import { updateFilterOptions } from "../utils/filterManager.js";
import { toast } from "../../../layout/app-toast/utils/toastManager.js";
import { validateData, getContent, removeStaleRow, deleteRecord } from "./tableManager.js";
import { currentTable } from "../../../../app/viewManager.js";

async function collectData() {
    const content = getContent();
    if (!content) return null;
    return {
        Name:     content.querySelector("#inputProjectName")?.getValue?.() ?? "",
        IsActive: content.querySelector("#checkboxIsActive")?.checked      ?? true,
    };
}

function sortByName() { currentTable.setSort("name", "asc"); }

export async function loadProjects() {
    const projects = await apiFetch("Projects?withoutFilter=true");
    currentTable.options.placeholder = "Keine Daten vorhanden";
    if (!Array.isArray(projects)) { currentTable.replaceData([]); return; }
    currentTable.setData(projects);
    sortByName();
    updateFilterOptions(projects, currentTable);
}

export async function createProject() {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const newProject = await apiFetch("Projects", "POST", { name: collectedData.Name });
    if (isErrorResult(newProject)) return newProject ? true : undefined;

    await currentTable.addRow(newProject, true);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Projekt erfolgreich hinzugefügt!", "success");
    return newProject;
}

export async function updateProject(projectId) {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const updatedProject = await apiFetch(`Projects/${projectId}`, "PATCH", {
        name:     collectedData.Name,
        isActive: collectedData.IsActive,
    });
    if (removeStaleRow(updatedProject, projectId)) return;
    if (isErrorResult(updatedProject)) return updatedProject ? true : undefined;

    await currentTable.updateOrAddData([updatedProject]);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Projekt erfolgreich aktualisiert!", "success");
    return updatedProject;
}

export const deleteProject = (projectId) => deleteRecord("Projects", projectId, "Projekt erfolgreich gelöscht!");
